import { render, staticRenderFns } from "./index.vue?vue&type=template&id=83e5dc8a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default,LayoutContainer: require('/opt/build/repo/components/Layout/Container/index.vue').default})
